/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useRef, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import {
  EditingState,
  SortingState,
  IntegratedSorting,
  SearchState,
  IntegratedFiltering,
  PagingState,
  IntegratedPaging,
  DataTypeProvider,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  TableEditColumn,
  Toolbar,
  SearchPanel,
  DragDropProvider,
  Table,
  TableColumnReordering,
  TableColumnVisibility,
  ColumnChooser,
  PagingPanel,
  TableColumnResizing,
} from '@devexpress/dx-react-grid-material-ui';
import { useUsers } from '../../hooks';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import {
  Box,
  Typography,
  Chip,
  Card,
  CardContent,
  IconButton,
  useMediaQuery,
  Button,
  ButtonGroup,
  TextField,
} from '@material-ui/core';
import useCompany from '../../hooks/useCompany';
import { useLazyQuery, useMutation } from '@apollo/client';
import { getSuggestions, getMySuggestions } from '../../graphql/query';
import {
  createSuggestion,
  deleteSuggestion,
  updateSuggestion,
} from '../../graphql/mutation';
import { getColumns } from '../constants/columns';
import { errorAlert, errorDeleteAlert, getRowId } from '../common/funcs';
import PageLayout from '../shared/PageLayout';
import { TableComponent } from '../components/TableComponent';
import { createdAtFormatter, userFormatter } from '../common/formater';
import { Command } from '../components/Command';
import SearchTable from '../components/SearchTable';
import PopupEditing from '../components/PopupEditing';
import AlertLocal from '../components/AlertLocal';
import PopupUrgentRequest from './PopupUrgentRequest';
import WarningIcon from '@material-ui/icons/Warning';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import PrintIcon from '@material-ui/icons/Print';
import GetAppIcon from '@material-ui/icons/GetApp';
import { roles } from '../../common/check';
import { useReactToPrint } from 'react-to-print';
import { downloadCSVFile } from '../../common';

const statusColors: any = {
  new: '#2196f3',
  reviewing: '#ff9800',
  approved: '#4caf50',
  rejected: '#f44336',
  implemented: '#9c27b0',
};

const statusLabelsAr: any = {
  new: 'جديد',
  reviewing: 'قيد المراجعة',
  approved: 'مقبول',
  rejected: 'مرفوض',
  implemented: 'تم التنفيذ',
};

const statusLabelsEn: any = {
  new: 'New',
  reviewing: 'Reviewing',
  approved: 'Approved',
  rejected: 'Rejected',
  implemented: 'Implemented',
};

export default function UrgentRequests({ isRTL, words, theme, menuitem }: any) {
  const [alrt, setAlrt] = useState({ show: false, msg: '', type: undefined });
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterType, setFilterType] = useState<string>('all');
  const [startDate, setStartDate] = useState<string>(() => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), 1)
      .toISOString()
      .slice(0, 10);
  });
  const [endDate, setEndDate] = useState<string>(() => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth() + 1, 0)
      .toISOString()
      .slice(0, 10);
  });

  const listPrintRef = useRef<any>();
  const handleListPrint = useReactToPrint({
    content: () => listPrintRef.current,
    documentTitle: isRTL ? 'قائمة الطلبات' : 'Requests List',
    removeAfterPrint: true,
  });

  const { height, width } = useWindowDimensions();
  const isMobile = useMediaQuery('(max-width:600px)');
  const { company } = useCompany();
  const { users } = useUsers();
  const col = getColumns({ isRTL, words });

  const isManager = roles.isSuperAdmin() || roles.isBranchAdmin();

  // Use the appropriate query based on role
  const mainQuery = isManager ? getSuggestions : getMySuggestions;
  const mainQueryName = isManager ? 'getSuggestions' : 'getMySuggestions';

  const columns = [
    col.createdAt,
    { name: 'title', title: isRTL ? 'العنوان' : 'Title' },
    { name: 'category', title: isRTL ? 'نوع الطلب' : 'Type' },
    { name: 'status', title: isRTL ? 'الحالة' : 'Status' },
    {
      name: isRTL ? 'employeeNameAr' : 'employeeName',
      title: isRTL ? 'الموظف' : 'Employee',
    },
    col.userId,
  ];

  const [tableColumnExtensions]: any = useState([
    { columnName: 'createdAt', width: 150 },
    { columnName: 'title', width: 250 },
    { columnName: 'category', width: 140 },
    { columnName: 'status', width: 130 },
    { columnName: isRTL ? 'employeeNameAr' : 'employeeName', width: 180 },
    { columnName: 'userId', width: 120 },
  ]);

  const [loadData, dataResult]: any = useLazyQuery(mainQuery, {
    fetchPolicy: 'cache-and-network',
  });

  const refresQuery = {
    refetchQueries: [
      {
        query: mainQuery,
        variables: isManager ? {} : undefined,
      },
    ],
  };

  const [addSuggestion] = useMutation(createSuggestion, refresQuery);
  const [editSuggestion] = useMutation(updateSuggestion, refresQuery);
  const [removeSuggestion] = useMutation(deleteSuggestion, refresQuery);

  useEffect(() => {
    loadData({
      variables: isManager ? {} : undefined,
    });
  }, []);

  useEffect(() => {
    if (dataResult?.loading) {
      setLoading(true);
    }
    if (dataResult?.data?.[mainQueryName]?.data) {
      let data = dataResult.data[mainQueryName].data;
      // Filter to only regular and urgent categories
      data = data.filter(
        (d: any) => d.category === 'urgent' || d.category === 'regular',
      );
      setRows(data);
      setLoading(false);
    }
  }, [dataResult]);

  const filteredRows = rows.filter((r: any) => {
    if (filterType !== 'all' && r.category !== filterType) return false;
    if (startDate) {
      const rowDate = new Date(r.createdAt);
      const start = new Date(startDate);
      start.setHours(0, 0, 0, 0);
      if (rowDate < start) return false;
    }
    if (endDate) {
      const rowDate = new Date(r.createdAt);
      const end = new Date(endDate);
      end.setHours(23, 59, 59, 999);
      if (rowDate > end) return false;
    }
    return true;
  });

  const commitChanges = async ({ deleted }: any) => {
    if (deleted) {
      const _id = deleted[0];
      const res = await removeSuggestion({ variables: { _id } });
      if (res?.data?.deleteSuggestion?.ok === false) {
        if (res?.data?.deleteSuggestion?.error?.includes('related')) {
          await errorDeleteAlert(setAlrt, isRTL);
        } else {
          await errorAlert(setAlrt, isRTL);
        }
      }
    }
  };

  const refresh = () => {
    loadData({
      variables: isManager ? {} : undefined,
    });
  };

  const categoryLabelsAr: any = {
    urgent: 'طلب عاجل',
    regular: 'طلب عادي',
  };

  const categoryLabelsEn: any = {
    urgent: 'Urgent',
    regular: 'Regular',
  };

  const categoryColors: any = {
    urgent: '#f44336',
    regular: '#2196f3',
  };

  const statusFormatter = ({ value }: any) => {
    return (
      <Chip
        size="small"
        label={isRTL ? statusLabelsAr[value] : statusLabelsEn[value] || value}
        style={{
          backgroundColor: statusColors[value] || '#9e9e9e',
          color: '#fff',
        }}
      />
    );
  };

  // Mobile card view for each row
  const [openAdd, setOpenAdd] = useState(false);
  const [editRow, setEditRow] = useState<any>(null);

  const MobileCardView = () => (
    <Box style={{ padding: 10 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        style={{ marginBottom: 10 }}
      >
        <Typography style={{ fontWeight: 'bold', fontSize: 18 }}>
          {isRTL ? 'الطلبات العاجلة' : 'Urgent Requests'}
        </Typography>
        <IconButton
          onClick={() => {
            setEditRow(null);
            setOpenAdd(true);
          }}
          style={{ backgroundColor: '#f44336', color: '#fff' }}
          size="small"
        >
          <AddIcon />
        </IconButton>
      </Box>

      {filteredRows.length === 0 && (
        <Typography style={{ textAlign: 'center', padding: 20, color: '#999' }}>
          {isRTL ? 'لا يوجد طلبات' : 'No requests'}
        </Typography>
      )}

      {filteredRows.map((row: any) => (
        <Card
          key={row._id}
          style={{
            marginBottom: 10,
            borderRight: `4px solid ${statusColors[row.status] || '#9e9e9e'}`,
          }}
        >
          <CardContent style={{ padding: 12 }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="flex-start"
            >
              <Box style={{ flex: 1 }}>
                <Typography style={{ fontWeight: 'bold', fontSize: 16 }}>
                  {row.title}
                </Typography>
                {row.desc && (
                  <Typography
                    variant="body2"
                    style={{ color: '#666', marginTop: 4 }}
                  >
                    {row.desc}
                  </Typography>
                )}
                <Box
                  display="flex"
                  alignItems="center"
                  style={{ marginTop: 8, gap: 8 }}
                >
                  <Chip
                    size="small"
                    label={
                      isRTL
                        ? statusLabelsAr[row.status]
                        : statusLabelsEn[row.status] || row.status
                    }
                    style={{
                      backgroundColor: statusColors[row.status] || '#9e9e9e',
                      color: '#fff',
                    }}
                  />
                  <Chip
                    size="small"
                    label={
                      isRTL
                        ? categoryLabelsAr[row.category] || row.category
                        : categoryLabelsEn[row.category] || row.category
                    }
                    style={{
                      backgroundColor:
                        categoryColors[row.category] || '#9e9e9e',
                      color: '#fff',
                    }}
                  />
                  {(isRTL ? row.employeeNameAr : row.employeeName) && (
                    <Typography variant="caption" style={{ color: '#888' }}>
                      {isRTL ? row.employeeNameAr : row.employeeName}
                    </Typography>
                  )}
                </Box>
                <Typography
                  variant="caption"
                  style={{ color: '#aaa', marginTop: 4, display: 'block' }}
                >
                  {row.createdAt
                    ? new Date(row.createdAt).toLocaleDateString(
                        isRTL ? 'ar' : 'en',
                      )
                    : ''}
                </Typography>
              </Box>
              <Box display="flex" flexDirection="column" style={{ gap: 4 }}>
                <IconButton
                  size="small"
                  onClick={() => {
                    setEditRow(row);
                    setOpenAdd(true);
                  }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={async () => {
                    const res = await removeSuggestion({
                      variables: { _id: row._id },
                    });
                    if (res?.data?.deleteSuggestion?.ok === false) {
                      await errorAlert(setAlrt, isRTL);
                    }
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            </Box>
          </CardContent>
        </Card>
      ))}

      {openAdd && (
        <PopupUrgentRequest
          open={openAdd}
          onClose={() => {
            setOpenAdd(false);
            setEditRow(null);
          }}
          row={editRow}
          isNew={!editRow}
          addAction={addSuggestion}
          editAction={editSuggestion}
          theme={theme}
          words={words}
          company={company}
        />
      )}
    </Box>
  );

  return (
    <PageLayout
      menuitem={menuitem}
      isRTL={isRTL}
      words={words}
      theme={theme}
      refresh={refresh}
      loading={loading}
    >
      <Box
        style={{
          height: height - 50,
          overflow: 'auto',
        }}
      >
        {/* Summary Card */}
        <Box
          display="flex"
          style={{
            margin: isMobile ? '10px' : '10px 25px',
            gap: 16,
            flexWrap: 'wrap',
            alignItems: 'center',
          }}
        >
          <Card
            style={{
              minWidth: isMobile ? '100%' : 200,
              backgroundColor: '#f44336',
              color: '#fff',
            }}
          >
            <CardContent>
              <Box display="flex" alignItems="center">
                <WarningIcon
                  style={{
                    fontSize: 40,
                    marginRight: isRTL ? 0 : 16,
                    marginLeft: isRTL ? 16 : 0,
                  }}
                />
                <Box>
                  <Typography variant="h4">{filteredRows.length}</Typography>
                  <Typography variant="body2">
                    {isRTL ? 'الطلبات' : 'Requests'}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>

          <ButtonGroup
            variant="outlined"
            style={{ direction: isRTL ? 'rtl' : 'ltr' }}
          >
            <Button
              onClick={() => setFilterType('all')}
              style={{
                backgroundColor: filterType === 'all' ? '#9e9e9e' : undefined,
                color: filterType === 'all' ? '#fff' : undefined,
              }}
            >
              {isRTL ? 'الكل' : 'All'}
            </Button>
            <Button
              onClick={() => setFilterType('regular')}
              style={{
                backgroundColor:
                  filterType === 'regular' ? '#2196f3' : undefined,
                color: filterType === 'regular' ? '#fff' : undefined,
              }}
            >
              {isRTL ? 'طلب عادي' : 'Regular'}
            </Button>
            <Button
              onClick={() => setFilterType('urgent')}
              style={{
                backgroundColor:
                  filterType === 'urgent' ? '#f44336' : undefined,
                color: filterType === 'urgent' ? '#fff' : undefined,
              }}
            >
              {isRTL ? 'طلب عاجل' : 'Urgent'}
            </Button>
          </ButtonGroup>

          {/* Date range filter */}
          <TextField
            label={isRTL ? 'من تاريخ' : 'From Date'}
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            size="small"
            style={{ width: 160 }}
          />
          <TextField
            label={isRTL ? 'إلى تاريخ' : 'To Date'}
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            size="small"
            style={{ width: 160 }}
          />
          {(startDate || endDate) && (
            <Button
              size="small"
              variant="outlined"
              onClick={() => {
                setStartDate('');
                setEndDate('');
              }}
            >
              {isRTL ? 'مسح' : 'Clear'}
            </Button>
          )}

          {/* Export & Print list buttons */}
          <Box display="flex" style={{ gap: 8 }}>
            <IconButton
              size="small"
              title={isRTL ? 'تصدير CSV' : 'Export CSV'}
              onClick={() => {
                const cols = [
                  'createdAt',
                  'title',
                  'category',
                  'status',
                  isRTL ? 'employeeNameAr' : 'employeeName',
                ];
                downloadCSVFile(
                  filteredRows,
                  isRTL ? 'الطلبات' : 'requests',
                  cols,
                );
              }}
              style={{ backgroundColor: '#e8f5e9', borderRadius: 8 }}
            >
              <GetAppIcon style={{ color: '#4caf50' }} />
            </IconButton>
            <IconButton
              size="small"
              title={isRTL ? 'طباعة القائمة' : 'Print List'}
              onClick={handleListPrint}
              style={{ backgroundColor: '#e3f2fd', borderRadius: 8 }}
            >
              <PrintIcon style={{ color: '#2196f3' }} />
            </IconButton>
          </Box>
        </Box>
        {isMobile ? (
          <MobileCardView />
        ) : (
          <>
            <Box
              display="flex"
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                margin: '10px 25px',
              }}
            >
              <Typography
                style={{
                  fontWeight: 'bold',
                  fontSize: 20,
                }}
              >
                {isRTL ? 'الطلبات' : 'Requests'}
              </Typography>
            </Box>

            <Paper
              elevation={5}
              style={{
                margin: 25,
                marginTop: 10,
                overflow: 'auto',
                width: width - 300,
                borderRadius: 10,
              }}
            >
              <Grid rows={filteredRows} columns={columns} getRowId={getRowId}>
                <SortingState
                  defaultSorting={[
                    { columnName: 'createdAt', direction: 'desc' },
                  ]}
                />
                <EditingState onCommitChanges={commitChanges} />
                <SearchState />
                <PagingState defaultCurrentPage={0} defaultPageSize={10} />

                <IntegratedSorting />
                <IntegratedFiltering />
                <IntegratedPaging />

                <DragDropProvider />

                <Table
                  messages={{
                    noData: isRTL
                      ? 'لا يوجد طلبات عاجلة'
                      : 'No urgent requests',
                  }}
                  tableComponent={TableComponent}
                  rowComponent={(props: any) => (
                    <Table.Row {...props} style={{ height: 50 }}></Table.Row>
                  )}
                  columnExtensions={tableColumnExtensions}
                />

                <TableColumnReordering
                  defaultOrder={[
                    'createdAt',
                    'title',
                    'category',
                    'status',
                    isRTL ? 'employeeNameAr' : 'employeeName',
                    'userId',
                  ]}
                />
                <TableColumnResizing
                  defaultColumnWidths={tableColumnExtensions}
                />
                <TableHeaderRow
                  showSortingControls
                  titleComponent={({ children }) => {
                    return (
                      <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                        {children}
                      </Typography>
                    );
                  }}
                />
                <TableColumnVisibility
                  defaultHiddenColumnNames={[]}
                  messages={{
                    noColumns: isRTL ? 'لا يوجد اعمدة' : 'No columns',
                  }}
                />

                <DataTypeProvider
                  for={['createdAt']}
                  formatterComponent={createdAtFormatter}
                />
                <DataTypeProvider
                  for={['category']}
                  formatterComponent={({ value }: any) => (
                    <Chip
                      size="small"
                      label={
                        isRTL
                          ? categoryLabelsAr[value] || value
                          : categoryLabelsEn[value] || value
                      }
                      style={{
                        backgroundColor: categoryColors[value] || '#9e9e9e',
                        color: '#fff',
                      }}
                    />
                  )}
                />
                <DataTypeProvider
                  for={['status']}
                  formatterComponent={statusFormatter}
                />
                <DataTypeProvider
                  for={['userId']}
                  formatterComponent={({ value }: any) =>
                    userFormatter({ value, users, isRTL })
                  }
                />

                <TableEditColumn
                  showAddCommand
                  showEditCommand
                  showDeleteCommand
                  commandComponent={Command}
                ></TableEditColumn>

                <Toolbar />
                <ColumnChooser />
                <PagingPanel
                  pageSizes={[5, 10, 20, 50, 0]}
                  messages={{
                    info: isRTL
                      ? ({ from, to, count }: any) =>
                          ` من ${from} الى ${to} المجموع ${count}`
                      : undefined,
                    rowsPerPage: isRTL ? 'عدد السطور' : undefined,
                  }}
                />
                <SearchPanel
                  inputComponent={(props: any) => {
                    return <SearchTable isRTL={isRTL} {...props}></SearchTable>;
                  }}
                />

                <PopupEditing
                  theme={theme}
                  addAction={addSuggestion}
                  editAction={editSuggestion}
                  alrt={alrt}
                  setAlrt={setAlrt}
                >
                  <PopupUrgentRequest
                    isRTL={isRTL}
                    words={words}
                    theme={theme}
                    company={company}
                  ></PopupUrgentRequest>
                </PopupEditing>
              </Grid>
            </Paper>
          </>
        )}

        {alrt.show && (
          <AlertLocal
            isRTL={isRTL}
            type={alrt?.type}
            msg={alrt?.msg}
            top
          ></AlertLocal>
        )}

        {/* Hidden list print component */}
        <div style={{ display: 'none' }}>
          <div
            ref={listPrintRef}
            style={{
              padding: 40,
              fontFamily: 'Arial, sans-serif',
              direction: isRTL ? 'rtl' : 'ltr',
            }}
          >
            <Typography
              variant="h5"
              style={{ fontWeight: 'bold', marginBottom: 8 }}
            >
              {isRTL ? 'قائمة الطلبات' : 'Requests List'}
            </Typography>
            <Typography
              variant="body2"
              style={{ color: '#777', marginBottom: 24 }}
            >
              {new Date().toLocaleDateString(isRTL ? 'ar' : 'en-GB')}
            </Typography>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: 12,
              }}
            >
              <thead>
                <tr style={{ backgroundColor: '#f5f5f5' }}>
                  <th style={thStyle}>#</th>
                  <th style={thStyle}>{isRTL ? 'التاريخ' : 'Date'}</th>
                  <th style={thStyle}>{isRTL ? 'العنوان' : 'Title'}</th>
                  <th style={thStyle}>{isRTL ? 'النوع' : 'Type'}</th>
                  <th style={thStyle}>{isRTL ? 'الحالة' : 'Status'}</th>
                  <th style={thStyle}>{isRTL ? 'الموظف' : 'Employee'}</th>
                  <th style={thStyle}>{isRTL ? 'التفاصيل' : 'Details'}</th>
                </tr>
              </thead>
              <tbody>
                {filteredRows.map((r: any, idx: number) => (
                  <tr key={r._id} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={tdStyle}>{idx + 1}</td>
                    <td style={tdStyle}>
                      {r.createdAt
                        ? new Date(r.createdAt).toLocaleDateString(
                            isRTL ? 'ar' : 'en-GB',
                          )
                        : ''}
                    </td>
                    <td style={{ ...tdStyle, fontWeight: 'bold' }}>
                      {r.title}
                    </td>
                    <td style={tdStyle}>
                      {isRTL
                        ? categoryLabelsAr[r.category] || r.category
                        : categoryLabelsEn[r.category] || r.category}
                    </td>
                    <td style={tdStyle}>
                      {isRTL
                        ? statusLabelsAr[r.status] || r.status
                        : statusLabelsEn[r.status] || r.status}
                    </td>
                    <td style={tdStyle}>
                      {isRTL ? r.employeeNameAr : r.employeeName}
                    </td>
                    <td style={{ ...tdStyle, maxWidth: 200 }}>{r.desc}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Box>
    </PageLayout>
  );
}

const thStyle: React.CSSProperties = {
  padding: '8px 12px',
  textAlign: 'left',
  fontWeight: 'bold',
  borderBottom: '2px solid #ddd',
};
const tdStyle: React.CSSProperties = {
  padding: '6px 12px',
  verticalAlign: 'top',
};
